import { ChevronLeft } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router";
import { SubmitOrderForm } from "@/components/forms/submit-order-form";
import { Steps } from "@/components/steps";
import { Button } from "@/components/ui/button";

export default function Summary() {
  const { service } = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="space-y-12">
      <Steps className="mx-auto flex max-w-2xl" currentStep={3} />

      <SubmitOrderForm serviceType={service as ServiceType} />

      <Button onClick={() => navigate(-1)} variant="outline">
        <ChevronLeft />
        <span>{t("labels.back")}</span>
      </Button>
    </div>
  );
}
